import { DictType } from "@pma/types"
import { create } from "zustand"

export type Context = "project" | "invite" | "task" | "folder" | "workspace" | "ai"

interface useModalStore {
  isOpen: boolean
  onOpen: () => void
  onClose: () => void
  context: Context | undefined
  setContext: (context: Context | undefined) => void
  metaData?: DictType
  setMetaData: (metaData: DictType | undefined) => void

  [key: string]: any
}

export const useModal = create<useModalStore>((set) => ({
  isOpen: false,
  context: undefined,
  metaData: {},
  onOpen: () => set({ isOpen: true }),
  onClose: () => set({ isOpen: false }),
  setContext: (context: Context | undefined) => {
    set({
      context,
    })
  },
  setMetaData: (metaData: DictType | undefined) => {
    set({
      metaData,
    })
  },
}))
